export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'period', label: 'Period' },
    { key: 'org', label: 'Organization' },
    { key: 'dsc', label: 'Dc amount' },
    { key: 'phd', label: 'Phd amount' },
    { key: 'target_dsc', label: 'Dc targeted amount' },
    { key: 'target_phd', label: 'Phd targeted amount' },
    { key: 'intern', label: 'Trainee amount' },
    { key: 'reject_info', label: 'Rejected Info' },
    { key: 'status', label: 'Status' },
    { key: 'file', label: 'Fayl' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
